import { render, staticRenderFns } from "./ItensPedido.vue?vue&type=template&id=07f6e4e7&scoped=true&"
import script from "./ItensPedido.vue?vue&type=script&lang=js&"
export * from "./ItensPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f6e4e7",
  null
  
)

export default component.exports